<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <ellipse cx="16" cy="16" rx="6.64" ry="6.67" />
    <path
        d="M16,0h0a1.78,1.78,0,0,1,1.77,1.78V4.44A1.77,1.77,0,0,1,16,6.22h0a1.78,1.78,0,0,1-1.77-1.78V1.78A1.78,1.78,0,0,1,16,0Z" />
    <path
        d="M16,25.78h0a1.77,1.77,0,0,1,1.77,1.78v2.66A1.78,1.78,0,0,1,16,32h0a1.78,1.78,0,0,1-1.77-1.78V27.56A1.78,1.78,0,0,1,16,25.78Z" />
    <path
        d="M29.8,24a1.76,1.76,0,0,1-2.41.65l-2.3-1.33a1.79,1.79,0,0,1-.55-2.46,1.77,1.77,0,0,1,2.32-.62l2.3,1.33A1.79,1.79,0,0,1,29.8,24Z" />
    <path
        d="M7.57,11.11a1.77,1.77,0,0,1-2.42.65L2.86,10.43A1.79,1.79,0,0,1,2.32,8a1.76,1.76,0,0,1,2.31-.62l2.3,1.33a1.79,1.79,0,0,1,.66,2.41Z" />
    <path
        d="M29.8,8a1.79,1.79,0,0,1-.64,2.43l-2.3,1.33A1.76,1.76,0,0,1,24.47,11a1.78,1.78,0,0,1,.62-2.33l2.3-1.33A1.76,1.76,0,0,1,29.8,8Z" />
    <path
        d="M7.57,20.89a1.79,1.79,0,0,1-.63,2.42L4.63,24.65a1.77,1.77,0,0,1-2.39-.75,1.79,1.79,0,0,1,.62-2.33l2.3-1.33A1.77,1.77,0,0,1,7.57,20.89Z" />
</svg>